<div class="list">
  <div class="entry" *ngFor="let o of orders$ | async">
    <div>{{ o.id }} {{o.created_at|date:"dd.MM.yy"}} {{o.number}}</div>
    <div class="actions">
      <button mat-raised-button color="primary" [routerLink]="['/orders', o.id]">
        Link
      </button>
    </div>
</div>
